import { Component, OnInit } from '@angular/core';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';

@Component({
  selector: 'app-follow-us',
  templateUrl: './follow-us.page.html',
  styleUrls: ['./follow-us.page.scss'],
})
export class FollowUsPage implements OnInit {
  socialLinks=[
    {
      name:'Facebook',
      icon:'logo-facebook',
      link:'https://www.facebook.com/groups/864869013856025'
    },
    {
      name:'TikTok',
      icon: 'logo-tiktok',
      link:'https://www.tiktok.com/@thehalalguide?lang=en'
    },
    {
      name:'Instagram',
      icon: 'logo-instagram',
      link:'https://www.instagram.com/thehalalguide_/'
    }
  ]
  constructor(
    private inapp:InAppBrowser
  ) { }

  ngOnInit() {
  }
  openUrl(link){
      this.inapp.create(link.link);
  }
}
